import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Select, Input, message, Row, Col, Radio } from 'antd';
import { APIs } from '../utils/apis';
import { connect } from 'react-redux';
import { fetchActiveReportsMetaData } from '../actions/sessionActions';
import Loader from '../sharedComponent/Loader';

const { Option } = Select;
const { TextArea } = Input;

const NPSConfig = ({ fetchActiveReportsMetaData, metadata }) => {
  const [state, setState] = useState({
    enterpriseKey: null,
    isLoading: false,
    isFormLoading: false
  });
  const [formState, setFormState] = useState({
    id: null,
    q1: '',
    q2: '',
    q3: '',
    q4: '',
    active: false
  });

  const fetchData = enterpriseKey => {
    return axios({
      url: `${APIs.NPS.CUSTOM_QUESTIONS}key=${enterpriseKey}`,
      method: 'GET'
    }).then(res => {
      if ('meta' in res.data && !res.data.meta.success) {
        return message.error(res.data?.meta?.message ?? 'Fetch API Failed');
      }
      state.isFormLoading = false;
      setState({ ...state });

      setFormState({
        ...formState,
        id: res?.data?.id ?? null,
        q1: res?.data?.q1 ?? '',
        q2: res?.data?.q2 ?? '',
        q3: res?.data?.q3 ?? '',
        q4: res?.data?.q4 ?? '',
        active: res?.data?.active ?? false
      });
      return res;
    });
  };

  const handleChange = (fieldName, value) => {
    if (fieldName === 'enterpriseKey') {
      state[fieldName] = value;
      setState({ ...state });

      if (value) {
        state.isFormLoading = true;
        setState({ ...state });
        fetchData(value);
      }
    } else {
      formState[fieldName] = value;
      setFormState({ ...formState });
    }
  };

  const onSubmit = () => {
    if (formState?.id === null) {
      delete formState.id;
    }
    return axios({
      url: `${APIs.NPS.CUSTOM_QUESTIONS}key=${state.enterpriseKey}`,
      method: formState.id ? 'PUT' : 'POST',
      data: formState
    }).then(res => {
      if (res?.status === 200) {
        return message.success('Data successfully submitted');
      }
      return message.error(res?.data?.meta?.message ?? 'API Error');
    });
  };

  const onChange = e => {
    const { name, value } = e.target;
    formState[name] = value;
    setFormState({ ...formState });
  };

  useEffect(() => {
    state.isLoading = true;
    setState({ ...state });
    fetchActiveReportsMetaData('enterprise').then(() => {
      state.isLoading = false;
      setState({ ...state });
    });
  }, []);

  return (
    <div>
      <h2>Configure NPS Custom Questions</h2>
      {state.isLoading ? (
        <Loader />
      ) : (
        <>
          <Row>
            <Col span={24}>
              <Select
                showSearch
                style={{ width: '25%' }}
                placeholder="Select enterprise"
                optionFilterProp="children"
                value={state.enterpriseKey ? state.enterpriseKey : undefined}
                onChange={value => handleChange('enterpriseKey', value)}
                allowClear={true}
              >
                {metadata.enterprise.list.map((enterprise, i) => (
                  <Option key={i} value={enterprise.key}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </Col>
            {state.isFormLoading && <Loader />}{' '}
            {!state.isFormLoading && state.enterpriseKey && (
              <>
                <Col span={24} className="margin-top-10">
                  <p className="margin-top-10">Is Active?</p>
                  <Radio.Group
                    name="active"
                    onChange={onChange}
                    value={formState.active}
                    className="margin-bottom-20"
                  >
                    <Radio value={true}>True</Radio>
                    <Radio value={false}>False</Radio>
                  </Radio.Group>
                </Col>
                {['q1', 'q2', 'q3', 'q4'].map((questionKey, idx) => (
                  <Col span={24} key={questionKey} className="margin-top-10">
                    <div style={{ width: '50%' }}>
                      <p>Question {idx + 1}</p>
                      <TextArea
                        name={questionKey}
                        placeholder={`Question ${idx + 1}`}
                        className="ant-input"
                        value={formState[questionKey]}
                        onChange={e =>
                          handleChange(questionKey, e.target.value)
                        }
                        cols={2}
                      />
                    </div>
                  </Col>
                ))}

                <Col span={6} className="margin-top-10">
                  <Button type="primary" onClick={onSubmit}>
                    Submit
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </div>
  );
};

NPSConfig.propTypes = {
  metadata: PropTypes.object,
  config: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query))
});

export default connect(mapStateToProps, mapDispatchToProps)(NPSConfig);
